import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const FormTableButton = props => {
  const { children, className, badge, disabled, ...rest } = props;

  const cName = classNames(
    {
      'form-table-button': true,
      disabled,
    },
    className
  );

  return (
    <div className={cName} {...rest}>
      {children}
      {badge !== undefined && <div className="badge">{badge}</div>}
    </div>
  );
};

FormTableButton.defaultProps = {
  badge: null,
  children: null,
  className: '',
  disabled: false,
};

FormTableButton.propTypes = {
  badge: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  children: PropTypes.node,
  className: PropTypes.string,
  disabled: PropTypes.bool,
};

export default FormTableButton;
